import Keycloak from "keycloak-js";
import { appConfig } from "@quest/appConfig";

export const keycloak = new Keycloak({
  url: appConfig.keycloakUrl,
  realm: appConfig.keyclokRealm,
  clientId: appConfig.keycloakClientId,
});

